/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shield': {
    width: 18,
    height: 22,
    viewBox: '0 0 18 22',
    data: '<path d="M9 0L0 4V10C0 15.55 3.84 20.74 9 22C14.16 20.74 18 15.55 18 10V4L9 0ZM7 16L3 12L4.41 10.59L7 13.17L13.59 6.58L15 8L7 16Z" fill="#46BF4A"/>'
  }
})
